import { render } from "./certificates.vue?vue&type=template&id=4e0093de&scoped=true"
import script from "./certificates.vue?vue&type=script&lang=js"
export * from "./certificates.vue?vue&type=script&lang=js"

import "./certificates.vue?vue&type=style&index=0&id=4e0093de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0093de"]])

export default __exports__